import Reflection from '../reflection.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Reflection.destroy((id, fetch) =>
  fetch.delete(`/reflections/${id}`)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
